export const APP_INIT = 'APP_INIT';
export const SYNC_ROUTER_VALUES = 'SYNC_ROUTER_VALUES';
export const RESTORE_CACHED_VALUES = 'RESTORE_CACHED_VALUES';